import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  tableRow: {
    borderBottom: `1px solid ${colors.neutral[300]}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    letterSpacing: '0.02rem',
    padding: '1.6rem 0rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
      paddingRight: '2rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  completeFormButton: {
    textTransform: 'uppercase',
    padding: '0 1.2rem',
  },
  completedCardWrapper: {
    color: colors.green[600],
    display: 'inline-flex',
    alignItems: 'center',
  },
  inProgressWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    color: colors.orange[600],
  },
  incompleteWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  cardStatusText: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  completedIcon: {
    marginRight: '0.4rem',
    width: '2.3rem',
  },
  incompletedIcon: {
    marginRight: '0.4rem',
    width: '2.3rem',
  },
  inProgressIcon: {
    marginRight: '0.4rem',
    width: '2.3rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
